module.exports = __webpack_public_path__ + "img/389.e0c9ebd7.svg";